import { DataProvider } from 'react-admin';

/**
 * Fake provider, required because react-admin requires a dataProvider
 * However, it seems we are not using it at all!
 * We could move out of React Admin and use a more simple solution.
 * @deprecated
 * @returns
 */
const notImplemented = (method: string) => () =>
  // Rejecting with a real Error rather than `undefined`. A bare
  // `Promise.reject()` surfaces in Sentry as "Non-Error promise rejection
  // captured with value: undefined", which carries no stack and no indication
  // of where it came from — it was the single largest issue in this project.
  Promise.reject(new Error(`dataProvider.${method} is not implemented`));

const dataProvider = (): DataProvider => {
  return {
    getList: notImplemented('getList'),
    getOne: notImplemented('getOne'),
    getMany: notImplemented('getMany'),
    getManyReference: notImplemented('getManyReference'),
    update: notImplemented('update'),
    updateMany: notImplemented('updateMany'),
    create: notImplemented('create'),
    delete: notImplemented('delete'),
    deleteMany: notImplemented('deleteMany'),
  };
};

export default dataProvider;
